import { Store } from './interfaces'

function registerPayloadFormater(registerStore: Store) {
  const payload = {
    cpf: registerStore.cpf,
    phone_number: registerStore.register.cellphone,
    country_code: '55',
    name: registerStore.register.fullName,
    selfie: registerStore.register.selfie,
    password: registerStore.register.password,
    vehicle: {
      plate: registerStore.plate,
      rntrc: registerStore.register.rntrc,
      body_id: Number(registerStore.register.vehicleBody),
      type_id: Number(registerStore.register.vehicleType),
      tracker_id: Number(registerStore.register.vehicleTracking),
    },
  }

  return payload
}

export default registerPayloadFormater
